import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useFaqs } from '../hooks/useWebsiteContent';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { Loader2 } from 'lucide-react';

const FAQSection = () => {
  const { language } = useLanguage();
  const { faqs, loading } = useFaqs();

  const content = {
    en: {
      title: "Frequently Asked Questions",
      subtitle: "Everything you need to know about our courses"
    },
    ar: {
      title: "الأسئلة المتكررة",
      subtitle: "كل ما تحتاج معرفته عن دوراتنا"
    }
  };

  const t = content[language];

  return (
    <section id="faq" className="py-20 bg-gradient-to-br from-slate-50 to-teal-50/30" aria-labelledby="faq-heading">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 id="faq-heading" className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">{t.title}</h2>
            <p className="text-xl text-gray-600">{t.subtitle}</p>
          </div>

          {/* FAQ Accordion */}
          <div className="bg-white rounded-2xl shadow-lg p-8">
            {loading ? (
              <div className="flex items-center justify-center py-12">
                <Loader2 className="w-8 h-8 animate-spin text-teal-600" />
              </div>
            ) : (
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((item, index) => (
                <AccordionItem key={item.id} value={`item-${index}`}>
                  <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:text-teal-600 transition-colors">
                    {item.question[language]}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 leading-relaxed">
                    {item.answer[language]}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
            )}
          </div>

          {/* CTA Card */}
          <div className="mt-12 bg-gradient-to-r from-teal-600 to-emerald-600 rounded-2xl p-8 text-center text-white shadow-xl">
            <h3 className="text-2xl font-bold mb-4">
              {language === 'en' ? "Still have questions?" : "لا تزال لديك أسئلة؟"}
            </h3>
            <p className="mb-6 text-teal-50">
              {language === 'en' 
                ? "Our team is here to help. Contact us anytime!" 
                : "فريقنا هنا للمساعدة. اتصل بنا في أي وقت!"}
            </p>
            <button className="bg-white text-teal-600 px-8 py-3 rounded-xl font-semibold hover:bg-teal-50 transition-colors shadow-lg">
              {language === 'en' ? 'Contact Support' : 'اتصل بالدعم'}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
